import "./scss/frontend.scss";
import "./scss/woocommerce.scss";
import "./scss/wordpress.scss";
import "./fonts/fonts.css";
import "../template-parts/navbar/navbar.scss";
import "../template-parts/hero/hero";
import "../template-parts/image-rich-text/image-rich-text";
import "../template-parts/modal/modal.scss";
import "../template-parts/mini-cart/mini-cart.scss";
import "../template-parts/mini-cart/mini-cart";
import "../template-parts/menu/menu";
import "../template-parts/menu/menu.scss";
import "../template-parts/navbar/navbar";
import "../template-parts/products-grid/products-grid";
import "../template-parts/products-grid/products-grid.scss";
import "../template-parts/product-card/product-card.scss";
import "../template-parts/main-acf/main-acf";

const elements = {
	menu: document.getElementById("nav-menu"),
	orderReviewWrapper: document.querySelector(".opc_order_review"),
	woocommerceMessages: () =>
		Array.from(
			document.querySelectorAll(
				".woocommerce-message, .woocommerce-error, .woocommerce-info"
			)
		),
};

window.addEventListener("error", function (event) {
	console.log("ERROR!");
	document.body.classList.add("loaded");
});

window.addEventListener("load", function () {
	document.body.classList.add("loaded");
});

// Function to add event listeners to WooCommerce messages
function addListenersToMessages(messages) {
	messages?.forEach((woocommerceMessage) => {
		woocommerceMessage.addEventListener("click", () => {
			woocommerceMessage.setAttribute("data-acknowledged", "true");
		});

		woocommerceMessage.addEventListener("animationend", (event) => {
			if (event.animationName === "fadeOut") {
				woocommerceMessage.style.display = "none";
			}
		});
	});
}

// Initial setup
addListenersToMessages(elements.woocommerceMessages());

// Create a Mutation Observer to watch for changes in the DOM
const observer = new MutationObserver((mutationsList) => {
	for (const mutation of mutationsList) {
		if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
			// New nodes have been added to the DOM, so re-add event listeners
			addListenersToMessages(elements.woocommerceMessages());
		}
	}
});

// Start observing changes in the DOM
observer.observe(document.body, { childList: true, subtree: true });
